import { useCallback, useEffect, useMemo, useState } from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer'
import Carousel from '../../Components/Carousel/Carousel'
import LoadPicture from '../../Func/LoadPicture'
import LoadDataNewsActivity from '../../Func/LoadDataNewsActivity'
import LoadingCenterPage from '../../Components/Loading/LoadingCenterPage'

const HomeNewsActivity = () => {
    // --- คงตัวแปรและการทำงานเดิมไว้ทั้งหมด ---
    const [type, setType] = useState(null)
    const dataPictureNewsActivity = LoadPicture(type)
    const dataNewsActivity = LoadDataNewsActivity()
    
    const findName = useMemo(() => {
        const find = dataNewsActivity?.find(v => v.type === type)
        return find
    }, [dataNewsActivity, type])

    // Get Type
    const getType = useCallback(() => {
        const queryString = window.location.search;
        const url = new URLSearchParams(queryString);
        const sector = url.get("type");

        if (!!sector) {
            setType(sector)
        }
    }, [])

    useEffect(() => {
        if (!type) {
            getType()
        }
    }, [getType, type])

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col">
            <Navbar />
            
            <main className="flex-grow">
                {!!dataPictureNewsActivity ? (
                    <div className="max-w-6xl mx-auto px-4 py-8 md:py-16">
                        
                        {/* ส่วนหัวข้อ (Header Section) */}
                        <div className="mb-10 relative">
                            {/* เส้นตกแต่งด้านข้างสไตล์โมเดิร์น */}
                            <div className="absolute -left-4 top-0 w-1.5 h-full bg-orange-500 rounded-full hidden md:block shadow-[0_0_10px_rgba(249,115,22,0.3)]"></div>
                            
                            <div className="flex flex-col gap-3">
                                <div className="flex items-center gap-2">
                                    <span className="px-3 py-1 bg-blue-900 text-white text-[10px] font-bold uppercase tracking-[0.2em] rounded-md">
                                        News Update
                                    </span>
                                    <div className="h-px flex-1 bg-slate-200"></div>
                                </div>
                                
                                <h1 className="text-3xl md:text-5xl font-black text-slate-900 leading-tight">
                                    {findName?.hname}
                                </h1>
                                
                                <div className="flex items-center text-slate-400 font-semibold mt-2 group">
                                    <div className="p-2 bg-white rounded-lg shadow-sm border border-slate-100 mr-3 text-orange-500 group-hover:bg-orange-500 group-hover:text-white transition-colors duration-300">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="size-5">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                        </svg>
                                    </div>
                                    <span className="text-base md:text-lg tracking-wide">
                                        {findName?.imgCover}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* ส่วนแสดงรูปภาพ (Carousel Section) */}
                        <div className="relative group">
                            {/* เอฟเฟกต์แสงฟุ้งด้านหลัง */}
                            <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-orange-400 rounded-[2.5rem] blur opacity-20 group-hover:opacity-30 transition duration-1000"></div>
                            
                            <div className="relative bg-white p-2 rounded-[2rem] md:rounded-[3rem] shadow-xl shadow-blue-900/5 border border-white">
                                <Carousel data={dataPictureNewsActivity} />
                            </div>
                        </div>

                        {/* ส่วนล่างสำหรับ Call to Action หรือข้อมูลเสริม */}
                        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="p-8 bg-blue-900 rounded-[2rem] text-white relative overflow-hidden group">
                                <div className="relative z-10">
                                    <h3 className="text-xl font-bold mb-2">ราชพฤกษ์ไตเทียม</h3>
                                    <p className="text-blue-100 text-sm leading-relaxed">มุ่งเน้นการให้บริการที่ได้มาตรฐาน และการดูแลผู้ป่วยด้วยหัวใจ เพื่อคุณภาพชีวิตที่ดีขึ้นอย่างยั่งยืน</p>
                                </div>
                                <div className="absolute -right-4 -bottom-4 opacity-10 group-hover:scale-110 transition-transform duration-700">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-32">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
                                    </svg>
                                </div>
                            </div>
                            
                            <div className="p-8 bg-orange-50 rounded-[2rem] border border-orange-100 flex flex-col justify-center items-center text-center">
                                <p className="text-orange-600 font-bold mb-4 italic">"ดูแลดุจญาติมิตร มาตรฐานสากล"</p>
                                <div className="flex gap-4">
                                    <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-orange-500 shadow-sm">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="size-5">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                                        </svg>
                                    </div>
                                    <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-blue-900 shadow-sm font-bold">f</div>
                                    <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-emerald-500 shadow-sm font-bold">L</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <LoadingCenterPage />
                )}
            </main>

            <Footer />
        </div>
    )
}

export default HomeNewsActivity